
import React from 'react'


export default React.createClass({


    

  render() {
    

    return (
      <div>
        Gertting started
        
      </div>
    )
  }
})




// WEBPACK FOOTER //
// ./src/GettingStarted.js